import { projects } from './projectsData';
import Projects from './Projects';

export default function ProjectSection() {
  return (
    <div
      id="projects"
      className="bg-whitish py-14 md:px-4 px-6 dark:bg-greenish flex justify-center items-center flex-col"
    >
      <h3 className="mb-10 text-center overline text-greenish text-4xl font-bold dark:text-beige">
        My Projects
      </h3>
      <div className="grid md:grid-cols-2 grid-cols-1 content-center justify-evenly justify-items-center gap-y-9 gap-x-5 md:w-3/4">
        {projects.map((project) => (
          <Projects key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
}
